__webpack_require__.p = "https://admin-asksalah.smartsway.com/";